import { render, staticRenderFns } from "./DetalleAutorizacion.vue?vue&type=template&id=521c0efd"
import script from "./DetalleAutorizacion.vue?vue&type=script&lang=ts"
export * from "./DetalleAutorizacion.vue?vue&type=script&lang=ts"
import style0 from "./DetalleAutorizacion.vue?vue&type=style&index=0&id=521c0efd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports